import { defineMutators } from "@rocicorp/zero";
import { crewMutators } from "./crew.mutators";
import { planMutators } from "./plans.mutators";
import { ticketAssignmentMutators } from "./ticket-assignment.mutators";
import { userAssignmentMutators } from "./user-assignment.mutators";
import { vehicleAssignmentMutators } from "./vehicle-assignment.mutators";
import { vehicleAssignmentPlanMutators } from "./vehicle-assignment-plan.mutators";

export const mutators = defineMutators({
	crews: crewMutators,
	userAssignments: userAssignmentMutators,
	ticketAssignments: ticketAssignmentMutators,
	plans: planMutators,
	vehicleAssignments: vehicleAssignmentMutators,
	vehicleAssignmentPlans: vehicleAssignmentPlanMutators,
});
